'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Search2 = function Search2(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 19 20' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M9 17.65A8.65 8.65 0 1 0 9 .35a8.65 8.65 0 0 0 0 17.3zm0-1.3a7.35 7.35 0 1 1 0-14.7 7.35 7.35 0 0 1 0 14.7z' }),
        _react2.default.createElement('path', { d: 'M14.04 15.96l3.536 3.535.46.46.919-.92-.46-.46-3.535-3.535-.46-.46-.92.92z' })
      )
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Search2;